
const AuditDataLoggerConfig = {
    shouldPushLog: true, // Set this value to true or false as needed
};

export default AuditDataLoggerConfig;
